import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a560c902cc25000144aeda3_1785492314363_0b5618c1/yafex/src/app/not-found.tsx");
